import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../shared/Sidebar";
import Image from "../components/elements/Image";
import Button from "../components/form/Button";
import { classNames } from "../helpers/classNames";
import DefaultHeader from "../shared/DefaultHeader";
import DefaultFooter from "../shared/DefaultFooter";
import { useDispatch, useSelector } from "react-redux";
import { profileSideBar } from "../components/elements/language";
import LogoutModal from "../components/elements/LogoutModal";
import { setAuthData } from "../store/slice/authSlice";
import { toast } from "react-toastify";
import { fetchProfileDetails } from "../service/profileService";
import { setProfileData } from "../store/slice/profileSlice";
import { useSocket } from "../components/socket/SocketProvider";
import { verifyToken, logoutRequest } from "../service/authService";
import { updateProfileService } from "../service/profileService";
import { setManualOffline } from "../util/consultantPresence";
import { appointmentClose } from "../service/videoCallService";
import Cookies from "js-cookie";

const InnerLayout = ({ profileTitle }) => {
  const [profileMenuToggle, setprofileMenuToggle] = useState(false);
  const lang = useSelector((state) => state?.languageSlice?.data);
  const language = localStorage.getItem("language") || lang;
  const [profile, setProfile] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userDetails") || "{}") || {};
    } catch {
      return {};
    }
  });
  const sideBarLang = profileSideBar;
  const userDetails = localStorage.getItem("userDetails");
  const role = userDetails && JSON.parse(userDetails)?.roleCode;
  const [showModal, setShowModal] = useState(false);
  const [loaded, setLoaded] = useState(true);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.initialProfileSlice.data);
  const socket = useSocket();
  const profiledata = useSelector((state) => state?.initialProfileSlice?.data);
  const appointmentData = JSON.parse(localStorage.getItem("appointmentData"));
  const token = localStorage.getItem("auth_token") || Cookies.get("auth_token");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!token) {
      navigate("/", { replace: true });
    }
  }, [token, navigate]);
  useEffect(() => {
    if (auth && auth?._id) {
      fetchProfileDetails(auth?._id, setProfile);
    }
  }, [auth]);
  useEffect(() => {
    if (profile && profile?._id) {
      dispatch(setProfileData(profile));
    }
  }, [profile, dispatch]);

  useEffect(() => {
    localStorage.removeItem("pageName");
  }, []);

  useEffect(() => {
    const path = String(location?.pathname || "");
    if (/^\/(chats|text-chat)\b/.test(path)) return undefined;
    const sweep = () =>
      import("../util/stopAllCallMedia")
        .then(({ stopAllCallMedia }) => stopAllCallMedia())
        .catch(() => { });
    sweep();
    const t = setTimeout(sweep, 800);
    return () => clearTimeout(t);
  }, [location?.pathname]);

  const sidebarData = [
    {
      _id: 1,
      link: "/control-panel",
      label: sideBarLang?.controlPanel?.[language],
      icon: "fa-regular fa-display-chart-up-circle-currency",
    },
    {
      _id: 2,
      link: "/profile",
      label: sideBarLang?.myProfile?.[language],
      icon: "fa-solid fa-user",
    },
    {
      _id: 3,
      link: `/consultant-profile/${auth?._id}`,
      // link: "/view-online",
      label: sideBarLang?.viewOnline?.[language],
      icon: "fa-solid fa-camera-viewfinder",
    },
    {
      _id: 4,
      link: "/appointments",
      label: sideBarLang?.appointments?.[language],
      icon: "fa-regular fa-bars",
    },
    {
      _id: 5,
      link: "/clients",
      label: sideBarLang?.myClients?.[language],
      icon: '"fa-solid fa-users',
    },
    {
      _id: 6,
      link: "/email",
      label: sideBarLang?.messages?.[language],
      icon: "fa-solid fa-envelope",
    },
    {
      _id: 7,
      link: "/reviews",
      label: sideBarLang?.myReviews?.[language],
      icon: "fa-solid fa-stars",
    },
    {
      _id: 8,
      // link: "/profile",
      label: sideBarLang?.logOut?.[language],
      icon: "fa-regular fa-arrow-right-from-bracket",
    },
  ];
  const userSidebarData = [
    {
      _id: 1,
      link: "/control-Panel",
      label: sideBarLang?.controlPanel?.[language],
      icon: "fa-regular fa-display-chart-up-circle-currency",
    },
    {
      _id: 2,
      link: "/profile",
      label: sideBarLang?.myProfile?.[language],
      icon: "fa-solid fa-user",
    },
    {
      _id: 3,
      link: "/appointments",
      label: sideBarLang?.appointments?.[language],
      icon: "fa-regular fa-bars",
    },
    {
      _id: 4,
      link: "/email",
      label: sideBarLang?.messages?.[language],
      icon: "fa-solid fa-envelope",
    },
    {
      _id: 5,
      link: "/wish-list",
      label: sideBarLang?.wishList?.[language],
      icon: "fa-solid fa-heart",
    },
    {
      _id: 6,
      // link: "/logout",
      // onClick: openModal,
      label: sideBarLang?.logOut?.[language],
      icon: "fa-regular fa-arrow-right-from-bracket",
    },
  ];
  const profileDetails = useSelector((state) => state.profileSlice.data);
  const activeUser = profileDetails?._id ? profileDetails : (profile?._id ? profile : (auth?._id ? auth : {}));
  const profileData = {
    image: activeUser?.image?.url || (typeof activeUser?.image === "string" ? activeUser?.image : ""),
    userName: (activeUser?.firstName || "") + " " + (activeUser?.lastName || ""),
    userEmail: activeUser?.email || "",
  };

  const getBannerTitle = () => {
    const path = String(location?.pathname || "");
    if (path.includes("/control-panel")) return sideBarLang?.controlPanel?.[language] || "Control Panel";
    if (path.includes("/profile")) return sideBarLang?.myProfile?.[language] || "My Profile";
    if (path.includes("/view-online")) return sideBarLang?.viewOnline?.[language] || "View Online";
    if (path.includes("/appointments-details")) return sideBarLang?.appointments?.[language] || "Appointments Details";
    if (path.includes("/appointments")) return sideBarLang?.appointments?.[language] || "Appointments";
    if (path.includes("/client-notes")) return sideBarLang?.myClients?.[language] || "Client Notes";
    if (path.includes("/clients")) return sideBarLang?.myClients?.[language] || "My Clients";
    if (path.includes("/email")) return sideBarLang?.messages?.[language] || "E-mail";
    if (path.includes("/reviews")) return sideBarLang?.myReviews?.[language] || "My Reviews";
    if (path.includes("/wish-list")) return sideBarLang?.wishList?.[language] || "Wish List";
    return profileTitle || "";
  };

  const isUserOnline = {
    status: "online",
    label1: "Online",
    label2: "Available",
  };

  const handleLogOut = () => {
    const rawUser = typeof localStorage !== "undefined" ? localStorage.getItem("userDetails") : null;
    let parsedUser = null;
    try {
      parsedUser = rawUser ? JSON.parse(rawUser) : null;
    } catch (_) { }

    const targetId = parsedUser?._id || auth?._id || profiledata?._id || profileDetails?._id;
    const currentToken = token || localStorage.getItem("auth_token") || Cookies.get("auth_token");

    // 1. Immediately notify socket of offline status
    if (socket && targetId) {
      try {
        socket.emit("userOffline", targetId);
        socket.emit("userOffline");
      } catch (_) { }
    } else if (socket) {
      try {
        socket.emit("userOffline");
      } catch (_) { }
    }

    // 2. Set manual offline flag
    setManualOffline(true);

    // 3. Update DB to offline before wiping token
    if (currentToken) {
      try {
        updateProfileService({ onlineStatus: "offline" });
      } catch (_) { }
      if (typeof fetch !== "undefined") {
        try {
          const BASE_URL = process.env.REACT_APP_API_URL || "https://dev.api.prontopsy.com/api/v1";
          const formData = new FormData();
          formData.append("onlineStatus", "offline");
          fetch(`${BASE_URL}/user/edit`, {
            method: "PUT",
            headers: { Authorization: `Bearer ${currentToken}` },
            body: formData,
            keepalive: true,
          }).catch(() => { });
        } catch (_) { }
      }
    }

    // 4. Send API logout request
    logoutRequest();

    // 5. Close appointment if any
    if (appointmentData && appointmentData?.appointmentId) {
      appointmentClose({
        appointmentId: appointmentData?.appointmentId,
      }).then((res) => {
        try {
          socket &&
            socket.emit("videoSessionDisconnect", {
              disconnect: true,
              appointmentId: appointmentData?.appointmentId,
            });
          localStorage.removeItem("joined");
          socket &&
            socket.emit("chatDisconnect", {
              disconnect: true,
              appointmentId: appointmentData?.appointmentId,
            });

          socket &&
            parsedUser?.roleCode === "consultant" &&
            socket.emit("consultantBusy", {
              consultantId: parsedUser?._id,
              userId: appointmentData?.callerData?.user?.id,
              isBusy: false,
            });

          socket &&
            socket.emit("userDisconnectFromCallNotify", {
              disconnected: false,
              sessionId: appointmentData.sessionId,
              userId: parsedUser?._id,
              appointmentId: appointmentData?.appointmentId,
            });
        } catch (_) { }
      });
    }

    // 6. Clear auth storage
    dispatch(setAuthData({}));
    localStorage.removeItem("auth_token");
    Cookies.remove("auth_token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userDetails");
    localStorage.removeItem("appointmentData");
    localStorage.removeItem("joined");

    // 7. Disconnect socket cleanly
    try {
      socket?.disconnect();
    } catch (_) { }

    toast.success("You are logged out!");
    setLoaded(false);
    setTimeout(() => {
      setShowModal(false);
      setLoaded(true);
      window.location.href = "/signin";
    }, 500);
  };

  useEffect(() => {
    verifyToken().then((res) => {
      if (res && (res?.status === 401 || res?.data?.status === 401)) {
        handleLogOut();
      }
    });
  }, []);

  return (
    <>
      <DefaultHeader headerClass={"!bg-white !shadow-md"} signinButton={false} headerProfileContent={true} />
      <div className="relative md:pt-32 pt-20">
        <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto mt-10">
          <div className="py-5 md:px-10 px-6 relative bg-prontopsy-blue rounded-t-2xl overflow-hidden">
            <div className="flex items-center justify-between gap-10 ">
              <div className="text-lg text-white font-UnisonPro font-bold italic uppercase">{getBannerTitle()}</div>
              <div className="relative xl:flex items-center gap-3 hidden">
                <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0 flex">
                  <Image src={profileData?.image} alt={""} effect={"blur"} className={"object-cover w-full h-full"} />
                </div>
                <div className="space-y-1 flex-shrink">
                  <div className="text-base xl:text-lg text-white font-UnisonPro font-bold italic uppercase">
                    {profileData?.userName || ""}
                  </div>
                  <div className="text-xs xl:text-sm text-white font-RobotoSlab font-normal uppercase">
                    {profileData?.userEmail || ""}
                  </div>
                </div>
              </div>
              <div className="relative block xl:hidden">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-arrow-right"}
                  buttonIconPosition={"left"}
                  buttonClasses={
                    "!px-0 text-xl aspect-square !rounded-lg !bg-prontopsy-yellow !text-black hover:!bg-prontopsy-blue hover:!text-prontopsy-yellow"
                  }
                  buttonFunction={() => setprofileMenuToggle(!profileMenuToggle)}
                />
              </div>
            </div>
          </div>
          <div className="flex justify-between gap-10 ">
            <div
              className={classNames(
                "fixed h-[calc(100vh+80px)] top-0 xl:relative w-72 bg-white left-0 z-10 xl:w-1/4 transition-all duration-200",
                profileMenuToggle
                  ? "translate-x-0 opacity-100 visible"
                  : "-translate-x-full xl:translate-x-0 opacity-0  lg:opacity-100 invisible xl:visible"
              )} style={{ zIndex: 13 }}>
              <Sidebar
                data={role === "user" ? userSidebarData : sidebarData}
                isOnline={isUserOnline}
                handleDelete={openModal}
                setprofileMenuToggle={setprofileMenuToggle}
              />
            </div>
            <div
              className={classNames(
                "fixed top-0 left-0 w-full h-screen z-[9] bg-black/25 transition-all duration-200 cursor-pointer",
                profileMenuToggle ? "opacity-80 visible" : "opacity-0 invisible"
              )}
              onClick={() => setprofileMenuToggle(false)}></div>
            <div className="w-full xl:w-3/4 py-2">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <DefaultFooter footerMenuContent={true} />

      <LogoutModal show={showModal} onClose={closeModal} onConfirm={handleLogOut} loaded={loaded} />
    </>
  );
};

export default InnerLayout;
